"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickUpApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var pickUpApi = exports.pickUpApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/pickUp",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/pickUp",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/pickUp/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  remove: function remove(id) {
    return (0, _request.default)({
      url: "/pickUp/".concat(id, "/delete"),
      method: "post"
    });
  }
};